module.exports = __webpack_public_path__ + "media/images/countrysquared/tg-f6b3b6ec59860662577a0ac4695fe739.svg";